import { ff } from '@atlassian/jira-feature-flagging';

export const isPollinatorTenant = () => ff('jsw.pollinator.tenants');
